import React from "react";
import { useNavigate } from "react-router-dom";
import winLogo from "./../../assets/images/logo-win.svg"
import Enroll from '../../assets/images/enroll.png';
import loginImage01 from "../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-04.jpg";


const CallWin = () => {
  const navigate = useNavigate();

  const handleOkay = () => {
    navigate("/login");
  };
  const handleBackClick = () => {
      navigate(-1); // Redirects to the home page
    };

  return (
    <>
      <div className="registration-block-main">
        {/* left carousel start */}
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>
        {/* left carousel end */}

        
        {/* registration right form area start */}
        <div className="registration-form-main">
          <div className="registration-form ">
            {/* back button just below header */}
      
            <div className="registration-process-form-wrapper mt-5">
              
              <div className="callwin-message mt-4">
                An email has been sent to{' '}
                <a href="mailto:winsuite-benefits@win-healthcare.com" className="callwin-link">
                  winsuite-benefits@win-healthcare.com
                </a>{' '}
                to confirm your eligibility for this program. Please call Maritza Torres directly at{' '}
                <a href="tel:9144123067" className="callwin-link">914-412-3067</a>{' '}
                if you have any questions.
              </div>
              <button  className="win-btn-primary mobile-view mt-5 mb-3 me-3" onClick={handleOkay}>Okay</button>
              <button  className="win-btn-secondary mobile-view mt-3 mb-3" onClick={handleBackClick}>Back </button>
            </div>
          </div>
        </div>
        {/* registration right form area end */}
      </div>
    </>
  );
};

export default CallWin;